import { Box, Skeleton } from "@mui/material";

interface skeletonLoaderProps {
  loaderType: string;
}

export const SkeletonLoader = (props: skeletonLoaderProps) => {
  // create a skeleton loader
  const { loaderType } = props;
  if (loaderType === "explore") {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginTop: "32px",
          marginBottom: "40px",
        }}>
        <Skeleton width="40%" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "22px",
            marginTop: "32px",
            marginBottom: "40px",
          }}>
          <Box>
            <Skeleton variant="rectangular" width={276} height={155} />
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
          <Box>
            <Skeleton variant="rectangular" width={276} height={155} />
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
          <Box>
            <Skeleton variant="rectangular" width={276} height={155} />
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
        </Box>
        <Skeleton width="60%" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "22px",
            marginTop: "32px",
            marginBottom: "40px",
          }}>
          <Skeleton variant="rectangular" width={276} height={276} />
          <Skeleton variant="rectangular" width={276} height={276} />
          <Skeleton variant="rectangular" width={276} height={276} />
        </Box>
      </Box>
    );
  } else {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          marginTop: "32px",
          marginBottom: "40px",
        }}>
        <Skeleton width="40%" />
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "22px",
            marginTop: "32px",
          }}>
          <Skeleton variant="rectangular" width={276} height={155} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
            }}>
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "22px",
            marginTop: "32px",
          }}>
          <Skeleton variant="rectangular" width={276} height={155} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
            }}>
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "22px",
            marginTop: "32px",
          }}>
          <Skeleton variant="rectangular" width={276} height={155} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "50%",
            }}>
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
        </Box>
      </Box>
    );
  }
};
